import { render, staticRenderFns } from "./CampaignInfo.vue?vue&type=template&id=79b5e902&"
import script from "./CampaignInfo.vue?vue&type=script&lang=js&"
export * from "./CampaignInfo.vue?vue&type=script&lang=js&"
import style0 from "./CampaignInfo.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79b5e902')) {
      api.createRecord('79b5e902', component.options)
    } else {
      api.reload('79b5e902', component.options)
    }
    module.hot.accept("./CampaignInfo.vue?vue&type=template&id=79b5e902&", function () {
      api.rerender('79b5e902', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wsgtdrive/components/CampaignInfo.vue"
export default component.exports